import CodeDepotList from "./pages/ListPage.vue";
import CodeDepotDetail from "./pages/FormPage.vue";
import CodeDepotIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_depot",
    component: CodeDepotIndex,
    redirect: "/code_depot/list",
    name: "code_depot",
    children: [
      {
        path: "list",
        component: CodeDepotList,
        name: "code_depot.list",
      },
      {
        path: "create",
        component: CodeDepotDetail,
        name: "code_depot.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeDepotDetail,
        name: "code_depot.edit",
        props: { create: false },
      },
    ],
  },
];
